export default __webpack_public_path__ + "static/2055-28f0841c44c750461c75eabd285b4354.gif";